import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BlogCustomModelPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "BlogCustomModelPopup" */ './Container'),
  'popup'
);
